import React, { useState } from "react";
import { Checkbox, Content } from "rsuite";
import {
    Grid,
    Header,
    Form,
    Button,
    Segment,
    Icon,
    Divider,
    Popup,
} from "semantic-ui-react";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import GoogleMapReact from "google-map-react";

import { api } from "../../services/api";
import { formatDate, formatPrice } from "../../utils";

import "./styles.css";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default function CardMap(props) {
    const {
        loadingCompet,
        loadingProducts,
        loadingUsers,
        ownProducts,
        users,
        compProducts,
    } = props.mapState;

    const [selectedVisits, setSelectedVisits] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [selectedInitialDate, setSelectedInitialDate] = useState(null);
    const [selectedFinalDate, setSelectedFinalDate] = useState(null);
    const [selectedProd, setSelectedProd] = useState("");

    const [prodPPreco, setProdPPreco] = useState([]);
    const [ownProdStock, setOwnProdStock] = useState([]);

    const [zoom, setZoom] = useState(10);

    const [filter, setFilter] = useState("");
    const [usingDateRange, setUsingDateRange] = useState(false);
    const [info, setInfo] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [buttonError, setButtonError] = useState(false);

    const optionsFilter1 = [
        { key: "usuario", value: "usuario", text: "Promotor" },
        { key: "produto", value: "produto", text: "Produto" },
        { key: "competidor", value: "competidor", text: "Competidor" },
    ];

    const infoFilter = [
        { key: "estoque", value: "estoque", text: "Estoque" },
        { key: "preço", value: "preço", text: "Preço" },
    ];

    const stocksThreshold = [
        { value: 0, color: "#c75757" },
        { value: 5, color: "#ccad00" },
        { value: 5, color: "#0274c0" },
    ];

    const handleInitialDateChange = (e, date) => {
        if (!selectedInitialDate) setButtonError(false);
        setSelectedInitialDate(date.value);
    };
    const handleFinalDateChange = (e, date) => {
        if (!selectedFinalDate) setButtonError(false);
        setSelectedFinalDate(date.value);
    };

    const handleUserChange = (e, { value }) => {
        setSelectedUser(value);
    };

    const handleProductChange = (e, { value }) => {
        setSelectedProd(value);
    };

    const handleFilterChange = (e, { value }) => {
        setFilter(value);
        setSelectedVisits([]);
        setSelectedUser("");
        setSelectedProd("");
        setInfo("");
        setButtonError(false);
        if (value === "competidor") setInfo("preço");
    };

    const handleInfoChange = (e, { value }) => {
        setInfo(value);
    };

    const formatDateToSQLTimestamp = (date) => {
        const pad = (num) => ("00" + num).slice(-2);
        return (
            date.getUTCFullYear() +
            "-" +
            pad(date.getUTCMonth() + 1) +
            "-" +
            pad(date.getUTCDate()) +
            " " +
            pad(date.getUTCHours()) +
            ":" +
            pad(date.getUTCMinutes()) +
            ":" +
            pad(date.getUTCSeconds())
        );
    };

    const updateMap = () => {
        setIsLoading(true);
        let prodPrices = [];
        let userVisits = [];
        let prodEst = [];

        const filterStuff = (visits) => {
            switch (filter) {
                case "produto":
                    userVisits = visits.filter((item) => {
                        let filterIn = false;
                        if (item["info"]) {
                            // console.log(item["info"]);
                            item["info"]["infoProprios"].forEach((prop) => {
                                if (prop["produto"]["id"] === selectedProd) {
                                    filterIn = true;
                                    prodPrices.push(
                                        formatPrice(prop["preco"].toString())
                                    );
                                    prodEst.push(prop["estoque"]);
                                }
                            });
                        }
                        return filterIn;
                    });

                    setSelectedVisits(userVisits);
                    setProdPPreco(prodPrices);
                    setOwnProdStock(prodEst);
                    break;

                case "competidor":
                    userVisits = visits.filter((item) => {
                        let filterIn = false;
                        if (item["info"]) {
                            item["info"]["infoCompetidores"].forEach((prop) => {
                                if (prop["produto"]["id"] === selectedProd) {
                                    filterIn = true;
                                    prodPrices.push(
                                        formatPrice(prop["preco"].toString())
                                    );
                                }
                            });
                        }
                        return filterIn;
                    });

                    setSelectedVisits(userVisits);
                    setProdPPreco(prodPrices);
                    break;

                case "usuario":
                    userVisits =
                        selectedUser !== "Todos"
                            ? visits.filter(
                                  (item) =>
                                      item["creator"]["email"] === selectedUser
                              )
                            : visits;

                    setSelectedVisits(userVisits);

                    break;

                default:
                    setSelectedVisits(userVisits);
                    break;
            }
        };

        const detectedError = () => {
            setSelectedVisits([]);
            setIsLoading(false);
            setButtonError(true);
        };

        if (!usingDateRange) {
            if (selectedInitialDate) {
                api.getVisitsByDate(
                    formatDateToSQLTimestamp(selectedInitialDate)
                )
                    .then((visits) => filterStuff(visits))
                    .finally(setIsLoading(false));
            } else {
                detectedError();
                return;
            }
        } else {
            if (selectedInitialDate && selectedFinalDate) {
                api.getVisitsByDateRange(
                    formatDateToSQLTimestamp(selectedInitialDate),
                    formatDateToSQLTimestamp(selectedFinalDate)
                )
                    .then((visits) => filterStuff(visits))
                    .finally(setIsLoading(false));
            } else {
                detectedError();
                return;
            }
        }
    };

    const changeMap = (e) => {
        setZoom(e.zoom);
    };

    const toggleDateRangeCheckbox = () => setUsingDateRange(!usingDateRange);

    return (
        <div>
            <Content className="m-content">
                <div>
                    <Segment
                        loading={
                            loadingCompet && loadingProducts && loadingUsers
                        }
                        style={{ boxShadow: "0 0 0 0 rgba(255, 255, 255, 0)" }}
                    >
                        <Header as="h3" floated="left">
                            Mapa
                        </Header>
                        {/*<Button
                        primary
                        size="mini"
                        floated='right'
                        //onClick={() => editUser(true)}
                        >
                            <div style={{ verticalAlign: 'middle', width: '100px', fontSize: '10px'}}>
                                <Icon name='refresh'/> Atualizar Dados
                            </div>
                    </Button>*/}
                        <Divider clearing />
                        <Checkbox
                            label="DateRange"
                            onCheckboxClick={toggleDateRangeCheckbox}
                            checked={usingDateRange}
                        >
                            <div style={{'fontSize': '15px', 'fontWeight': 'bold'}}>Período</div>
                            </Checkbox>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Select
                                    search
                                    fluid
                                    label="Promotor/Produto"
                                    options={optionsFilter1}
                                    value={filter}
                                    placeholder="Filtro"
                                    onChange={handleFilterChange}
                                />
                                {(filter === "usuario" || filter === "") && (
                                    <Form.Select
                                        search
                                        fluid
                                        label="Promotor"
                                        disabled={
                                            filter === "usuario" ? false : true
                                        }
                                        options={
                                            users &&
                                            users.map(function (user) {
                                                return {
                                                    key: user.email,
                                                    value: user.email,
                                                    text: user.nome,
                                                };
                                            })
                                        }
                                        value={selectedUser}
                                        placeholder="Selecione o promotor"
                                        onChange={handleUserChange}
                                    />
                                )}

                                {(filter === "produto" ||
                                    filter === "competidor" ||
                                    filter === "") && (
                                    <Form.Select
                                        search
                                        fluid
                                        label="Produto/Competidor"
                                        disabled={
                                            filter === "produto" ||
                                            filter === "competidor"
                                                ? false
                                                : true
                                        }
                                        options={
                                            filter === "produto"
                                                ? ownProducts &&
                                                  ownProducts.map(function (
                                                      prod
                                                  ) {
                                                      return {
                                                          key: prod.id,
                                                          value: prod.id,
                                                          text: prod.nome,
                                                      };
                                                  })
                                                : compProducts &&
                                                  compProducts.map(function (
                                                      prod
                                                  ) {
                                                      return {
                                                          key: prod.id,
                                                          value: prod.id,
                                                          text: prod.nome,
                                                      };
                                                  })
                                        }
                                        value={selectedProd}
                                        placeholder="Selecione o produto"
                                        onChange={handleProductChange}
                                    />
                                )}

                                {(filter === "produto" || filter === "") && (
                                    <Form.Select
                                        fluid
                                        label="Estoque/Preço"
                                        disabled={
                                            filter === "produto" ? false : true
                                        }
                                        options={infoFilter}
                                        value={info}
                                        placeholder="Selecione estoque ou preço"
                                        onChange={handleInfoChange}
                                    />
                                )}
                                <SemanticDatepicker
                                    allowOnlyNumbers
                                    fluid
                                    label={
                                        usingDateRange ? "Dia Inicial" : "Dia"
                                    }
                                    onChange={handleInitialDateChange}
                                    locale="pt-BR"
                                    format="DD/MM/YYYY"
                                    showToday={true}
                                />
                                {usingDateRange && (
                                    <SemanticDatepicker
                                        allowOnlyNumbers
                                        fluid
                                        label="Dia Final"
                                        onChange={handleFinalDateChange}
                                        locale="pt-BR"
                                        format="DD/MM/YYYY"
                                        showToday={true}
                                    />
                                )}
                            </Form.Group>
                            <Button
                                primary
                                size="medium"
                                onClick={updateMap}
                                type="submit"
                                color={buttonError ? "red" : undefined}
                            >
                                <div
                                    style={{
                                        verticalAlign: "middle",
                                        width: "100px",
                                        fontSize: "10px",
                                    }}
                                >
                                    <Icon
                                        name="refresh"
                                        className={isLoading ? "rotate" : ""}
                                        disabled={isLoading}
                                    />{" "}
                                    Atualizar Mapa
                                </div>
                                {buttonError && <div>Data não inserida!</div>}
                            </Button>
                        </Form>
                    </Segment>
                </div>
                <div
                    className="border border-light"
                    style={{
                        height: "91vh",
                        width: "100%",
                        marginTop: "1vh",
                        borderColor: "#2BBBAD",
                    }}
                >
                    <GoogleMapReact
                        bootstrapURLKeys={{
                            key: "AIzaSyCo3WPgRE9HelkR1kl3NczxwmTJA6_M_dM",
                        }}
                        yesIWantToUseGoogleMapApiInternals
                        //onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps, selectedVisits)}
                        onChange={(e) => changeMap(e)}
                        center={{
                            lat: -20.2,
                            lng: -40.4,
                        }}
                        zoom={zoom}
                    >
                        {selectedVisits.map((visit, index) => {
                            let latitude = visit["checkout"]
                                ? visit["checkout"]["latitude"]
                                : visit["checkin"]["latitude"];
                            let longitude = visit["checkout"]
                                ? visit["checkout"]["longitude"]
                                : visit["checkin"]["longitude"];

                            return (
                                <AnyReactComponent
                                    key={visit["id"]}
                                    lat={latitude}
                                    lng={longitude}
                                    text={
                                        <Popup
                                            size="mini"
                                            wide
                                            offset={
                                                filter === "competidor" ||
                                                filter === "produto"
                                                    ? "0, 40"
                                                    : "-40, 10"
                                            }
                                            position="right center"
                                            header={
                                                <Header
                                                    as="h5"
                                                    content={
                                                        visit["loja"]["nome"]
                                                    }
                                                    dividing
                                                />
                                            }
                                            content={
                                                <Grid columns="equal" centered>
                                                    <Grid.Row
                                                        style={{
                                                            marginBottom:
                                                                "10px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <Header
                                                                as="h5"
                                                                content="Informações Gerais"
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row
                                                        style={{
                                                            marginTop: "-30px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <div
                                                                style={{
                                                                    fontSize:
                                                                        "12px",
                                                                }}
                                                            >
                                                                Promotor:{" "}
                                                                {
                                                                    visit[
                                                                        "creator"
                                                                    ]["nome"]
                                                                }
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row
                                                        style={{
                                                            marginTop: "-30px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <div
                                                                style={{
                                                                    fontSize:
                                                                        "12px",
                                                                }}
                                                            >
                                                                Pontos Extras:{" "}
                                                                {visit[
                                                                    "pontosExtra"
                                                                ]
                                                                    ? visit[
                                                                          "pontosExtra"
                                                                      ][
                                                                          "imagensExtra"
                                                                      ].length
                                                                    : 0}
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row
                                                        style={{
                                                            marginTop: "-30px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <div
                                                                style={{
                                                                    fontSize:
                                                                        "12px",
                                                                }}
                                                            >
                                                                Data Checkin:{" "}
                                                                {formatDate(
                                                                    visit[
                                                                        "checkin"
                                                                    ]["date"]
                                                                )}
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row
                                                        style={{
                                                            marginTop: "-30px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <div
                                                                style={{
                                                                    fontSize:
                                                                        "12px",
                                                                }}
                                                            >
                                                                Data Checkout:{" "}
                                                                {visit[
                                                                    "checkout"
                                                                ]
                                                                    ? formatDate(
                                                                          visit[
                                                                              "checkout"
                                                                          ][
                                                                              "date"
                                                                          ]
                                                                      )
                                                                    : ""}
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row
                                                        style={{
                                                            marginBottom:
                                                                "10px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <Header
                                                                as="h5"
                                                                content="Produtos"
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    {visit["info"] &&
                                                        visit["info"][
                                                            "infoProprios"
                                                        ].map(
                                                            (prop, indexP) => (
                                                                <Grid.Row
                                                                    key={indexP}
                                                                    style={{
                                                                        marginTop:
                                                                            "-27px",
                                                                    }}
                                                                >
                                                                    <Grid.Column>
                                                                        <div
                                                                            style={{
                                                                                fontSize:
                                                                                    "10px",
                                                                            }}
                                                                        >
                                                                            {
                                                                                prop[
                                                                                    "produto"
                                                                                ][
                                                                                    "nome"
                                                                                ]
                                                                            }{" "}
                                                                            /
                                                                            Estoque:{" "}
                                                                            {
                                                                                prop[
                                                                                    "estoque"
                                                                                ]
                                                                            }{" "}
                                                                            /
                                                                            Preço:{" "}
                                                                            {formatPrice(
                                                                                prop[
                                                                                    "preco"
                                                                                ].toString()
                                                                            )}
                                                                        </div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            )
                                                        )}

                                                    <Grid.Row
                                                        style={{
                                                            marginBottom:
                                                                "10px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <Header
                                                                as="h5"
                                                                content="Competidores"
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    {visit["info"] &&
                                                        visit["info"][
                                                            "infoCompetidores"
                                                        ].map(
                                                            (prop, indexC) => (
                                                                <Grid.Row
                                                                    key={indexC}
                                                                    style={{
                                                                        marginTop:
                                                                            "-27px",
                                                                    }}
                                                                >
                                                                    <Grid.Column>
                                                                        <div
                                                                            style={{
                                                                                fontSize:
                                                                                    "10px",
                                                                            }}
                                                                        >
                                                                            {
                                                                                prop[
                                                                                    "produto"
                                                                                ][
                                                                                    "nome"
                                                                                ]
                                                                            }{" "}
                                                                            /
                                                                            Preço:{" "}
                                                                            {formatPrice(
                                                                                prop[
                                                                                    "preco"
                                                                                ].toString()
                                                                            )}
                                                                        </div>
                                                                    </Grid.Column>
                                                                </Grid.Row>
                                                            )
                                                        )}

                                                    <Grid.Row
                                                        style={{
                                                            marginBottom:
                                                                "10px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <Header
                                                                as="h5"
                                                                content="Observações"
                                                            />
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    <Grid.Row
                                                        style={{
                                                            marginTop: "-30px",
                                                        }}
                                                    >
                                                        <Grid.Column>
                                                            <div
                                                                style={{
                                                                    fontSize:
                                                                        "12px",
                                                                }}
                                                            >
                                                                {
                                                                    visit[
                                                                        "anotacao"
                                                                    ]
                                                                }
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                </Grid>
                                            }
                                            trigger={
                                                <div>
                                                    <div className="pin">
                                                        <div className="ident">
                                                            {index + 1}
                                                        </div>
                                                    </div>
                                                    {(filter === "produto" ||
                                                        filter ===
                                                            "competidor") && (
                                                        <div
                                                            className="box"
                                                            style={{
                                                                "background-color":
                                                                    ownProdStock[
                                                                        index
                                                                    ] ===
                                                                    stocksThreshold[0][
                                                                        "value"
                                                                    ]
                                                                        ? stocksThreshold[0][
                                                                              "color"
                                                                          ]
                                                                        : ownProdStock[
                                                                              index
                                                                          ] <=
                                                                          stocksThreshold[1][
                                                                              "value"
                                                                          ]
                                                                        ? stocksThreshold[1][
                                                                              "color"
                                                                          ]
                                                                        : stocksThreshold[2][
                                                                              "color"
                                                                          ],
                                                            }}
                                                        >
                                                            {info ===
                                                                "preço" && (
                                                                <div className="text-research">
                                                                    {
                                                                        prodPPreco[
                                                                            index
                                                                        ]
                                                                    }
                                                                </div>
                                                            )}
                                                            {info ===
                                                                "estoque" && (
                                                                <div className="text-research">
                                                                    {
                                                                        ownProdStock[
                                                                            index
                                                                        ]
                                                                    }
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            }
                                        />
                                    }
                                />
                            );
                        })}
                    </GoogleMapReact>
                </div>
            </Content>
        </div>
    );
}
